module.exports = __webpack_public_path__ + "static/media/RedInfo.3999cd34.svg";